import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { config } from '../config';

export const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
    const apiUrl = config.apiUrl;
    const imageUrl = config.imageUrl;
    
    // সমস্ত স্টেট
    const [heroes, setHeroes] = useState([]);
    const [homepages, setHomepages] = useState([]);
    const [blogs, setBlogs] = useState([]);
    const [testimonials, setTestimonials] = useState([]);
    const [courses, setCourses] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    // Retry helper function
    const retryRequest = async (fn, retries = 3, delay = 2000) => {
        try {
        return await fn();
        } catch (error) {
        if (retries > 0 && error.response?.status === 429) {
            console.warn(`⏳ Rate limit hit. Retrying in ${delay}ms...`);
            await new Promise(res => setTimeout(res, delay));
            return retryRequest(fn, retries - 1, delay * 2); // exponential backoff
        } else {
            throw error;
        }
        }
    };


  // সমস্ত ডেটা ফেচ করার ফাংশন
  const fetchHeaderData = useCallback(async () => {
    try {
        const [heroesRes, homepagesRes, blogsRes, testimonialsRes, coursesRes] = await Promise.all([
            retryRequest(() => axios.get(`${apiUrl}/heroes`)),
            retryRequest(() => axios.get(`${apiUrl}/homepages`)),
            retryRequest(() => axios.get(`${apiUrl}/blogs`)),
            retryRequest(() => axios.get(`${apiUrl}/testimonials`)),
            retryRequest(() => axios.get(`${apiUrl}/courses`)),
          ]);
          
          setHeroes(heroesRes.data.heroes[0]);
          setHomepages(homepagesRes.data.homepages[0]);
          setBlogs(blogsRes.data.blogs);
          setTestimonials(testimonialsRes.data.testimonials);
          setCourses(coursesRes.data.courses);



    } catch (err) {
      setError(err.message || "An error occurred");
      console.error("Header data fetch error:", err);
      
      // রিট্রাই লজিক
      if (err.response?.status === 429) {
        await new Promise(resolve => setTimeout(resolve, 2000));
        await fetchHeaderData();
      }
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchHeaderData();
  }, [fetchHeaderData]);
  

  return (
    <HeaderContext.Provider
      value={{
        heroes,
        courses,
        homepages,
        blogs,
        testimonials,
        apiUrl,
        imageUrl,
        loading,
        error,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};